(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  class InstagramGallery extends HTMLElement {
    #track = null;
    #prevBtn = null;
    #nextBtn = null;
    #controller = new AbortController();

    connectedCallback() {
      this.#track = this.querySelector('[data-ig-track]');
      this.#prevBtn = this.querySelector('[data-ig-prev]');
      this.#nextBtn = this.querySelector('[data-ig-next]');

      if (!this.#track) return;

      const { signal } = this.#controller;

      // Arrow navigation
      this.#prevBtn?.addEventListener('click', () => this.#scroll(-1), { signal });
      this.#nextBtn?.addEventListener('click', () => this.#scroll(1), { signal });

      // Update arrow visibility on scroll
      this.#track.addEventListener('scroll', () => this.#updateArrows(), { passive: true, signal });

      // Initial arrow state
      requestAnimationFrame(() => this.#updateArrows());
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    #scroll(direction) {
      if (!this.#track) return;
      const item = this.#track.querySelector('.ig-gallery__item');
      if (!item) return;

      const scrollAmount = (item.offsetWidth + 16) * direction;
      this.#track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    #updateArrows() {
      if (!this.#track || !this.#prevBtn || !this.#nextBtn) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.#track;
      const atStart = scrollLeft <= 4;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 4;

      this.#prevBtn.disabled = atStart;
      this.#nextBtn.disabled = atEnd;
    }
  }

  if (!customElements.get('instagram-gallery')) {
    customElements.define('instagram-gallery', InstagramGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
